const duplicateCompanyEmailType = {
  None: 0,
  CompanyAdmistrator: 1,
  B1SA_Support: 2,
};

export default duplicateCompanyEmailType;
